(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-warranty-upsell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    var container = document.getElementById('warranty-upsell');
    if (!container) return;

    var variantId = container.getAttribute('data-variant-id');
    var lineKey = container.getAttribute('data-line-key');

    function addWarranty() {
      var btn = document.getElementById('warranty-add-btn');
      if (!btn || !variantId) return;

      btn.disabled = true;
      btn.querySelector('.warranty-upsell__btn-text').style.display = 'none';
      btn.querySelector('.warranty-upsell__btn-loading').style.display = 'flex';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }]
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Add failed');
        window.location.reload();
      })
      .catch(function(err) {
        console.error('[Warranty Upsell]', err);
        btn.disabled = false;
        btn.querySelector('.warranty-upsell__btn-text').style.display = '';
        btn.querySelector('.warranty-upsell__btn-loading').style.display = 'none';
      });
    }

    function removeWarranty() {
      var key = lineKey || variantId;
      if (!key) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key.toString(), quantity: 0 })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Remove failed');
        window.location.reload();
      })
      .catch(function(err) {
        console.error('[Warranty Upsell]', err);
      });
    }

    var addBtn = document.getElementById('warranty-add-btn');
    if (addBtn) addBtn.addEventListener('click', addWarranty);

    var removeBtn = document.getElementById('warranty-remove-btn');
    if (removeBtn) removeBtn.addEventListener('click', removeWarranty);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
